var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import 'core-js/es6/promise';
import 'isomorphic-fetch';
function supportsES6() {
    try {
        console.info('Check if browser supposrt es6...');
        Function('() => {};');
        console.info('Browser does supposrt es6...');
        return true;
    }
    catch (err) {
        console.info('Browser does not supposrt es6...');
        return false;
    }
}
function polyfills() {
    return __awaiter(this, void 0, void 0, function () {
        var polyfillsPromises;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    polyfillsPromises = [];
                    if (!supportsES6()) {
                        polyfillsPromises.push(import(/* webpackChunkName: 'es6.polyfill' */ './polyfills/es6'));
                        console.info('Get es6 support...');
                    }
                    if (!window.fetch) {
                        polyfillsPromises.push(import(/* webpackChunkName: 'fetch.polyfill' */ 'isomorphic-fetch'));
                        console.info('Get fetch...');
                    }
                    if (!Object.entries) {
                        polyfillsPromises.push(import(/* webpackChunkName: 'entries.polyfill' */ './polyfills/entries'));
                        console.info('Get entries...');
                    }
                    if (!Object.assign) {
                        polyfillsPromises.push(import(/* webpackChunkName: 'assign.polyfill' */ './polyfills/assign'));
                        console.info('Get assign...');
                    }
                    if (!Array.prototype.includes) {
                        polyfillsPromises.push(import(/* webpackChunkName: 'assign.polyfill' */ './polyfills/includes'));
                        console.info('Get includes...');
                    }
                    if (!('scrollBehavior' in document.documentElement.style)) {
                        polyfillsPromises.push(import(/* webpackChunkName: 'smooth-scroll.polyfill' */ 'smoothscroll-polyfill')
                            .then(function (smoothScroll) { smoothScroll.polyfill(); return smoothScroll; }));
                    }
                    return [4 /*yield*/, Promise.all(polyfillsPromises)];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    });
}
export default polyfills;
//# sourceMappingURL=polyfills.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idse/core/services/polyfills.js
// module id = 981
// module chunks = 8